import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { ContentAreaBlock } from './content-area-block.js'
import { ButtonBlock } from '../form/button-block.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'

const ContextMenuXPositions = {
	before: 'Before trigger',
	after: 'After trigger',
} as const
export type ContextMenuXPosition = keyof typeof ContextMenuXPositions

const ContextMenuYPositions = {
	above: 'Above trigger',
	below: 'Below trigger',
} as const
export type ContextMenuYPosition = keyof typeof ContextMenuYPositions

@jsonClass('ContextMenuBlock')
export class ContextMenuBlock extends Block {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 1,
		label: 'Horizontal position',
		options: Object.entries(ContextMenuXPositions),
	})
	xPosition: ContextMenuXPosition = 'after'

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 2,
		label: 'Vertical position',
		options: Object.entries(ContextMenuYPositions),
	})
	yPosition: ContextMenuYPosition = 'below'

	constructor(init: Partial<ContextMenuBlock> = {}) {
		super()
		this.init(init)
	}

	static createNewForEditor(): Block {
		return new ContextMenuBlock({
			children: [
				new ContentAreaBlock({
					name: 'trigger',
					children: [
						new ButtonBlock({
							buttonType: 'mat-icon-button',
							textCode: new TextOrExpression_assumeExpression('Menu', 'T'),
						}),
					],
				}),
				new ContentAreaBlock({
					name: 'content',
					children: [
						new ButtonBlock({
							buttonType: 'mat-menu-item',
							textCode: new TextOrExpression_assumeExpression('Item 1', 'T'),
						}),
					],
				}),
			],
		})
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#b0bec5'
	}

	getTitleColor(): string {
		return '#263238'
	}

	getEditorCategory(): string {
		return 'Layout'
	}
}
